import { createForm } from 'final-form';
import {
  defaultDatepickerOptions,
  initializeDatepicker,
} from '../components/datepicker';

import { addPasswordHintToForm } from '../components/form/password_hint';

export const initializeForm = (
  formSelector,
  {
    initialValues = {},
    onSubmit = (_) => ({}),
    validate = (_) => ({}),
    fieldsToValidateWithoutTouch = [],
    preventDefault = true,
    skipInputs = ['submit', 'csrfmiddlewaretoken', 'button', 'form_type'],
    dateInputs = [],
    passwordHintField = '',
    formFieldsWrapper = null,
  }
) => {
  if (!formSelector.length) return;

  const formFields = formFieldsWrapper || formSelector;

  const form = createForm({
    initialValues,
    onSubmit,
    validate,
  });

  dateInputs.forEach((dateInput) => {
    const element = formFields.find(dateInput.selector).get(0);
    if (element) {
      initializeDatepicker(element, {
        ...defaultDatepickerOptions,
        ...dateInput.options,
      });
    }
  });

  formSelector.on('submit', ($event) => {
    if (preventDefault) {
      $event.preventDefault();
    }
    form.submit();
  });

  if (passwordHintField) {
    addPasswordHintToForm(formFields, passwordHintField);
  }

  const registered = {};

  formFields.find('input, select, textarea').each((_, input) => {
    if (skipInputs.includes(input.name) || skipInputs.includes(input.type))
      return;

    form.registerField(
      input.name,
      (fieldState) => {
        const { blur, change, error, focus, touched, value } = fieldState;
        const errorSection = formFields.find(`#${input.name}-error-section`);

        if (!registered[input.name]) {
          // first time, register event listeners
          input.addEventListener('blur', () => blur());
          input.addEventListener('input', (event) =>
            event.target.type !== 'file'
              ? event.target.type === 'checkbox'
                ? change(event.target.checked)
                : change(event.target.value)
              : change(event.target.files)
          );
          // custom event dispatched by custom select field
          input.addEventListener('selectChange', (event) => {
            const value = event.detail.value;
            change(value);
          });
          input.addEventListener('inputChange', (event) => {
            const value = event.detail.value;
            change(value);
            if (event.detail.resetFieldState) {
              form.resetFieldState(input.name);
            }
          });
          input.addEventListener('focus', () => focus());
          registered[input.name] = true;
        }

        // update value
        if (input.type !== 'file') {
          change(input.value || value || '');
        }

        // show/hide errors
        if (errorSection) {
          const backendValidated = errorSection.hasClass('backend-validated');
          const touchedCheck =
            touched || fieldsToValidateWithoutTouch.includes(input.name);

          // reset all error messages visibility inside error section
          errorSection
            .find('[data-error-type]')
            .switchClass('d-flex', 'd-none');
          if (error && (touchedCheck || backendValidated)) {
            input.classList.add('error');
            errorSection.switchClass('d-none', 'd-flex');
            // show the error message for the current error
            errorSection
              .find(`[data-error-type="${error}"]`)
              .switchClass('d-none', 'd-flex');
          } else {
            input.classList.remove('error');
            errorSection.switchClass('d-flex', 'd-none');
          }
        }
      },
      {
        value: true,
        error: true,
        touched: true,
      }
    );
  });

  return form;
};

export const appendAndGetUniqueFormElement = ({
  $elementToAppend,
  $formFields,
}) => {
  const uniqueId = `${Math.random()}`.substring(2);
  const formId = `${uniqueId}`;
  const formElement = `<form id="${formId}" method="POST"></form>`;
  $elementToAppend.append(formElement);
  // add newly created formId to input form attribute
  if ($formFields) {
    $formFields.find('input').attr('form', formId);
  }
  const $formElement = $(`#${formId}`);
  return $formElement;
};
